export const categories = [
  {
    id: 'movie',
    name: '电影',
    slug: 'dianying',
    icon: 'ri-film-line',
    description: '最新最热电影大片，涵盖动作、喜剧、爱情、科幻等多种类型，高清画质免费在线观看',
    keywords: '最新电影,免费电影,高清电影,动作片,喜剧片,爱情片,科幻片',
  },
  {
    id: 'tv',
    name: '电视剧',
    slug: 'dianshiju',
    icon: 'ri-tv-line',
    description: '热播电视剧全集在线观看，国产剧、韩剧、美剧、日剧应有尽有，精彩不断更',
    keywords: '电视剧,国产剧,韩剧,美剧,日剧,热播剧,电视剧全集',
  },
  {
    id: 'variety',
    name: '综艺',
    slug: 'zongyi',
    icon: 'ri-live-line',
    description: '热门综艺节目随时随地在线观看，真人秀、脱口秀、音乐节目、选秀比赛精彩纷呈',
    keywords: '综艺节目,真人秀,脱口秀,音乐节目,选秀,综艺全集',
  },
  {
    id: 'anime',
    name: '动漫',
    slug: 'dongman',
    icon: 'ri-ghost-line',
    description: '最新动漫番剧在线播放，国产动漫、日本动漫、欧美动漫，热门番剧每周更新',
    keywords: '动漫,番剧,国产动漫,日本动漫,动画片,动漫在线观看',
  },
  {
    id: 'documentary',
    name: '纪录片',
    slug: 'jilupian',
    icon: 'ri-earth-line',
    description: '精选高分纪录片，自然、历史、科技、人文、美食，带你探索世界万象',
    keywords: '纪录片,自然纪录片,历史纪录片,科技纪录片,人文纪录片,美食纪录片',
  },
];

export interface VideoItem {
  id: string;
  title: string;
  category: string;
  rating: number;
  views: string;
  year: number;
  region: string;
  duration: string;
  description: string;
  tags: string[];
  cast: string[];
  source: string;
  sourceUrl: string;
  updateDate: string;
  imageUrl: string;
}

export const allVideos: VideoItem[] = [
  {
    id: 'v001',
    title: '流浪地球3：星辰大海',
    category: 'movie',
    rating: 9.2,
    views: '1280万',
    year: 2026,
    region: '中国大陆',
    duration: '148分钟',
    description: '太阳急速老化膨胀，整个太阳系将被吞没。人类在地球表面建造的巨大推进器再度启动，带着家园踏上2500年的流浪之旅。这一次，人类将面对更为未知的深空挑战。',
    tags: ['科幻', '灾难', '冒险', '国产'],
    cast: ['吴京', '刘德华', '李雪健'],
    source: '西瓜视频',
    sourceUrl: 'https://www.ixigua.com/',
    updateDate: '2026-07-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20style%20with%20giant%20planet%20engines%20in%20space%2C%20dramatic%20warm%20orange%20and%20gold%20lighting%2C%20cinematic%20composition%2C%20Chinese%20blockbuster%20aesthetic%2C%20clean%20dark%20background%20with%20star%20field%2C%20movie%20poster%20quality&width=600&height=338&seq=vid-v001&orientation=landscape',
  },
  {
    id: 'v002',
    title: '长风破浪会有时',
    category: 'tv',
    rating: 8.9,
    views: '2560万',
    year: 2026,
    region: '中国大陆',
    duration: '40集/每集45分钟',
    description: '讲述了改革开放初期，一群怀揣梦想的年轻人在深圳经济特区创业奋斗的故事。他们面对重重困难，始终不忘初心，最终在时代浪潮中乘风破浪。',
    tags: ['年代', '创业', '励志', '国产剧'],
    cast: ['张译', '赵丽颖', '王凯'],
    source: '西瓜视频',
    sourceUrl: 'https://www.ixigua.com/',
    updateDate: '2026-07-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20set%20in%201980s%20Shenzhen%20with%20young%20entrepreneurs%2C%20warm%20nostalgic%20golden%20lighting%2C%20cinematic%20film%20poster%20style%2C%20retro%20Chinese%20aesthetic%2C%20clean%20composition%2C%20dramatic%20atmosphere&width=600&height=338&seq=vid-v002&orientation=landscape',
  },
  {
    id: 'v003',
    title: '极限挑战第十季',
    category: 'variety',
    rating: 8.7,
    views: '980万',
    year: 2026,
    region: '中国大陆',
    duration: '12期/每期90分钟',
    description: '国民综艺《极限挑战》第十季重磅回归！原班人马再度集结，全新赛制、全新挑战，带你感受最真实的欢笑与感动。',
    tags: ['真人秀', '户外', '搞笑', '挑战'],
    cast: ['黄渤', '孙红雷', '黄磊', '王迅', '张艺兴'],
    source: '菠萝视频',
    sourceUrl: 'https://www.boluovideo.com/',
    updateDate: '2026-07-25',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20outdoor%20challenge%20theme%20with%20colorful%20energetic%20vibe%2C%20bright%20warm%20lighting%2C%20entertainment%20show%20poster%20style%2C%20fun%20dynamic%20composition%2C%20clean%20background%20with%20vibrant%20colors&width=600&height=338&seq=vid-v003&orientation=landscape',
  },
  {
    id: 'v004',
    title: '深海迷航',
    category: 'movie',
    rating: 8.8,
    views: '890万',
    year: 2026,
    region: '中国大陆',
    duration: '135分钟',
    description: '一艘深海科研潜艇在执行任务时遭遇神秘海怪袭击。艇上六名科研人员被困在4000米深的漆黑海底，他们必须在氧气耗尽之前找到逃生的方法。',
    tags: ['惊悚', '科幻', '灾难', '悬疑'],
    cast: ['朱一龙', '倪妮', '段奕宏'],
    source: '青青草视频',
    sourceUrl: 'https://www.qqcvideo.com/',
    updateDate: '2026-07-20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20thriller%20movie%20poster%20with%20submarine%20in%20dark%20abyss%2C%20mysterious%20creature%20silhouette%2C%20dramatic%20teal%20and%20amber%20lighting%2C%20cinematic%20horror%20style%2C%20clean%20dark%20composition%2C%20suspenseful%20atmosphere&width=600&height=338&seq=vid-v004&orientation=landscape',
  },
  {
    id: 'v005',
    title: '长安十二时辰续：盛世危局',
    category: 'tv',
    rating: 9.0,
    views: '3200万',
    year: 2026,
    region: '中国大陆',
    duration: '48集/每集50分钟',
    description: '天宝三年，上元节前夕，长安城沉浸在节日的喜庆之中。然而一场针对皇室的惊天阴谋正在暗中酝酿。靖安司司丞再度临危受命，与时间赛跑，守护长安安危。',
    tags: ['古装', '悬疑', '历史', '权谋'],
    cast: ['雷佳音', '易烊千玺', '周一围'],
    source: '西瓜视频',
    sourceUrl: 'https://www.ixigua.com/',
    updateDate: '2026-07-29',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20drama%20poster%20with%20Changan%20city%20at%20night%2C%20lantern%20festival%20atmosphere%2C%20warm%20golden%20and%20red%20lighting%2C%20cinematic%20historical%20epic%20style%2C%20clean%20dramatic%20composition%2C%20palace%20intrigue%20aesthetic&width=600&height=338&seq=vid-v005&orientation=landscape',
  },
  {
    id: 'v006',
    title: '鬼灭之刃：无限城篇',
    category: 'anime',
    rating: 9.5,
    views: '5600万',
    year: 2026,
    region: '日本',
    duration: '120分钟',
    description: '炭治郎等人终于追踪到鬼舞辻无惨的藏身之处——无限城。在这里，鬼杀队与十二鬼月展开了最终决战，人类的命运在此一举。',
    tags: ['热血', '战斗', '奇幻', '日漫'],
    cast: ['花江夏树', '鬼头明里', '下野纮'],
    source: '菠萝视频',
    sourceUrl: 'https://www.boluovideo.com/',
    updateDate: '2026-07-15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20anime%20movie%20poster%20with%20samurai%20characters%20in%20ancient%20Japanese%20castle%2C%20dynamic%20flame%20effects%2C%20vibrant%20warm%20red%20and%20orange%20colors%2C%20Japanese%20animation%20style%2C%20clean%20heroic%20composition%2C%20action%20scene&width=600&height=338&seq=vid-v006&orientation=landscape',
  },
  {
    id: 'v007',
    title: '舌尖上的中国第五季',
    category: 'documentary',
    rating: 9.3,
    views: '1800万',
    year: 2026,
    region: '中国大陆',
    duration: '8集/每集50分钟',
    description: '《舌尖上的中国》第五季回归，这次摄制组走遍中国大江南北，从东北雪乡到海南椰林，从西北戈壁到东海渔村，探寻最地道的中国味道。',
    tags: ['美食', '人文', '旅行', '文化'],
    cast: ['李立宏'],
    source: '青青草视频',
    sourceUrl: 'https://www.qqcvideo.com/',
    updateDate: '2026-07-22',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20cuisine%20documentary%20poster%20with%20beautiful%20traditional%20dishes%20on%20rustic%20table%2C%20steam%20rising%2C%20warm%20intimate%20lighting%2C%20food%20photography%20style%2C%20clean%20rich%20composition%2C%20cultural%20Chinese%20aesthetic&width=600&height=338&seq=vid-v007&orientation=landscape',
  },
  {
    id: 'v008',
    title: '破茧',
    category: 'movie',
    rating: 8.5,
    views: '670万',
    year: 2026,
    region: '中国香港',
    duration: '118分钟',
    description: '一个被冤枉入狱的金融天才，出狱后用十年时间精心策划了一场完美的复仇。然而当他一步步接近真相时，却发现自己不过是更大棋局中的一枚棋子。',
    tags: ['犯罪', '悬疑', '剧情', '港片'],
    cast: ['刘青云', '古天乐', '张家辉'],
    source: '西瓜视频',
    sourceUrl: 'https://www.ixigua.com/',
    updateDate: '2026-07-18',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20thriller%20movie%20poster%20with%20mysterious%20man%20in%20suit%2C%20dark%20alley%20atmosphere%2C%20noir%20lighting%20with%20warm%20accents%2C%20cinematic%20style%2C%20clean%20suspenseful%20composition&width=600&height=338&seq=vid-v008&orientation=landscape',
  },
  {
    id: 'v009',
    title: '我们的歌第六季',
    category: 'variety',
    rating: 8.6,
    views: '750万',
    year: 2026,
    region: '中国大陆',
    duration: '12期/每期100分钟',
    description: '华语乐坛殿堂级音乐综艺再度来袭！新老歌手跨界组合，用歌声传递温暖与力量。本季更有国际巨星加盟，音乐无国界。',
    tags: ['音乐', '竞演', '真人秀', '歌唱'],
    cast: ['周深', '毛不易', '邓紫棋', '林俊杰'],
    source: '菠萝视频',
    sourceUrl: 'https://www.boluovideo.com/',
    updateDate: '2026-07-27',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%20with%20stage%20lights%20and%20microphone%2C%20warm%20golden%20spotlight%20effects%2C%20grand%20concert%20atmosphere%2C%20clean%20elegant%20composition%2C%20entertainment%20show%20aesthetic&width=600&height=338&seq=vid-v009&orientation=landscape',
  },
  {
    id: 'v010',
    title: '仙王的日常生活第四季',
    category: 'anime',
    rating: 9.1,
    views: '4200万',
    year: 2026,
    region: '中国大陆',
    duration: '24集/每集24分钟',
    description: '修真界最强仙王王令只想低调过完高中生活。然而事与愿违，各路强者纷至沓来，平静的校园日常再度掀起惊涛骇浪。',
    tags: ['搞笑', '校园', '修仙', '国漫'],
    cast: ['赵路', '陶典', '吴磊'],
    source: '青青草视频',
    sourceUrl: 'https://www.qqcvideo.com/',
    updateDate: '2026-07-26',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20school%20life%20comedy%20poster%20with%20fantasy%20cultivation%20elements%2C%20bright%20colorful%20animation%20style%2C%20warm%20vibrant%20lighting%2C%20clean%20dynamic%20composition%2C%20donghua%20aesthetic&width=600&height=338&seq=vid-v010&orientation=landscape',
  },
  {
    id: 'v011',
    title: '地球脉动第四季',
    category: 'documentary',
    rating: 9.7,
    views: '8900万',
    year: 2026,
    region: '英国',
    duration: '6集/每集60分钟',
    description: 'BBC史诗级自然纪录片《地球脉动》第四季，采用最先进的8K摄影技术，带你领略地球上最壮丽的自然奇观和野生动物的生存故事。',
    tags: ['自然', '动物', '地理', 'BBC'],
    cast: ['大卫·爱登堡'],
    source: '西瓜视频',
    sourceUrl: 'https://www.ixigua.com/',
    updateDate: '2026-07-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20majestic%20mountain%20landscape%20and%20wildlife%2C%20golden%20sunset%20lighting%2C%20epic%20cinematic%20style%2C%20clean%20breathtaking%20composition%2C%20BBC%20Earth%20aesthetic%2C%20natural%20beauty&width=600&height=338&seq=vid-v011&orientation=landscape',
  },
  {
    id: 'v012',
    title: '隐秘的角落2：暗夜追踪',
    category: 'tv',
    rating: 9.4,
    views: '4500万',
    year: 2026,
    region: '中国大陆',
    duration: '12集/每集55分钟',
    description: '一座海滨小城接连发生离奇失踪案。退休刑警老周发现这些看似无关的案件背后，隐藏着一个跨越二十年的惊天秘密。迷雾重重，真相只有一个。',
    tags: ['悬疑', '犯罪', '剧情', '短剧'],
    cast: ['秦昊', '王景春', '张子枫'],
    source: '西瓜视频',
    sourceUrl: 'https://www.ixigua.com/',
    updateDate: '2026-08-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20thriller%20drama%20poster%20with%20dark%20coastal%20town%20at%20night%2C%20fog%20and%20streetlights%2C%20noir%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20clean%20suspenseful%20composition%2C%20crime%20drama%20aesthetic&width=600&height=338&seq=vid-v012&orientation=landscape',
  },
];

export const featuredVideos = [
  'v012', 'v005', 'v006', 'v001', 'v011', 'v002',
];

export const hotVideos = [
  'v006', 'v012', 'v011', 'v005', 'v010', 'v001', 'v007', 'v002',
];

export const newVideos = [
  'v012', 'v002', 'v005', 'v009', 'v001', 'v010', 'v007', 'v003',
];

export const banners = [
  {
    id: 'b1',
    title: '隐秘的角落2：暗夜追踪 全网首播',
    subtitle: '悬疑神作续集重磅回归，原班人马再续暗黑传奇',
    videoId: 'v012',
    bgImage: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20coastal%20city%20at%20night%20with%20fog%20and%20warm%20streetlights%2C%20cinematic%20noir%20style%2C%20suspenseful%20atmosphere%2C%20digital%20art%20with%20deep%20shadows%20and%20warm%20golden%20accents%2C%20film%20poster%20quality%2C%20dramatic%20lighting%2C%20wide%20landscape&width=1600&height=700&seq=banner-b1&orientation=landscape',
  },
  {
    id: 'b2',
    title: '鬼灭之刃：无限城篇 燃爆今夏',
    subtitle: '最终决战开启！评分9.5，全球票房破纪录',
    videoId: 'v006',
    bgImage: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20in%20ancient%20Japanese%20castle%20with%20flame%20effects%2C%20dynamic%20action%20composition%2C%20vibrant%20warm%20red%20and%20orange%20colors%2C%20digital%20illustration%20style%2C%20cinematic%20wide%20shot%2C%20heroic%20atmosphere&width=1600&height=700&seq=banner-b2&orientation=landscape',
  },
  {
    id: 'b3',
    title: '舌尖上的中国第五季 温暖回归',
    subtitle: '走遍大江南北，寻味最地道的中国味道',
    videoId: 'v007',
    bgImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20cuisine%20flat%20lay%20with%20traditional%20dishes%20on%20rustic%20wooden%20table%2C%20warm%20intimate%20lighting%2C%20steam%20rising%20from%20food%2C%20rich%20textures%2C%20food%20photography%20style%2C%20artistic%20wide%20composition%2C%20cultural%20Chinese%20aesthetic&width=1600&height=700&seq=banner-b3&orientation=landscape',
  },
];